import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    container: {
      display: "flex",
      gap: "32px",
      flexDirection: "row",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
      },
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    leftSectionContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "32px",
      flex: "0.747",
    },
    rightSectionContainer: {
      display: "flex",
      flexDirection: "column",
      flex: "0.253",
      gap: "32px",
    },
  };
});
